import { z } from 'zod'
import type { StatusConexao } from '../enums'
import { textoObrigatorio } from './comum'
import type { Provedor } from './api-oficial'

/**
 * Números de WhatsApp (seção 8). Uma instância da Evolution API por número,
 * QR code exibido dentro da tela de configuração.
 */

export const criarConexaoSchema = z.object({
  nome: textoObrigatorio('nome da conexão', 80),
  numero: z.string().trim().min(10, 'informe o número com DDD').max(20),
  /**
   * ADR 0001: nasce em somente leitura. Durante o paralelo com o Digisac o
   * sistema apenas recebe e registra; ligar o envio é ato explícito.
   */
  somenteLeitura: z.boolean().default(true),
  usuarioIds: z.array(z.string().uuid()).default([]),
})
export type CriarConexaoEntrada = z.infer<typeof criarConexaoSchema>

export const atualizarConexaoSchema = z.object({
  nome: textoObrigatorio('nome da conexão', 80).optional(),
  somenteLeitura: z.boolean().optional(),
})

export const definirAcessoSchema = z.object({
  usuarioIds: z.array(z.string().uuid()),
})

export const ROTULO_STATUS_CONEXAO: Record<StatusConexao, string> = {
  conectado: 'Conectado',
  desconectado: 'Desconectado',
  aguardando_qr: 'Aguardando leitura do QR',
}

export interface ConexaoDto {
  id: string
  nome: string
  numero: string
  instanciaEvolution: string
  /** Por onde o número fala com o WhatsApp (ADR 0033). */
  provedor: Provedor
  status: StatusConexao
  somenteLeitura: boolean
  ultimaConexaoEm: string | null
  usuarios: { id: string; nome: string }[]
  mensagens: number
  chamadosAbertos: number
}

export interface QrCodeDto {
  /** data URI pronta para <img src>. Null quando já está conectado. */
  imagem: string | null
  codigo: string | null
  status: StatusConexao
}

/** Quantas mensagens ficaram de fora da importação, e por quê. */
export interface IgnoradasNaImportacao {
  total: number
  grupos: number
  identificadorSemNumero: number
  status: number
  semChave: number
}

export interface ProgressoImportacaoDto {
  paginas: number
  totalMensagens: number
  lidas: number
  gravadas: number
  reinterpretadas: number
  conversas: number
  contatosCriados: number
  contatosRenomeados: number
  chamadosCriados: number
  /** Downloads de mídia pedidos nesta rodada (regra 4). */
  midiasEnfileiradas: number
  /** Parou no teto de páginas, e não porque o histórico acabou. */
  interrompidaPorTeto: boolean
  ignoradas: IgnoradasNaImportacao
}

export interface ImportacaoDto {
  conexaoId: string
  situacao: 'nunca' | 'rodando' | 'concluida' | 'erro'
  iniciadaEm?: string
  terminadaEm?: string | null
  erro?: string | null
  progresso?: ProgressoImportacaoDto
}
